import React, { useEffect } from 'react';
import PageGraphic from '../components/PageGraphic';
import imgGrpahic from '../assets/img/testimonials.png';

const Testmonials = () => {
  useEffect(() => {
    document.title = 'Emprouen Advisors: Testimonials';
  }, []);

  return (
    <React.Fragment>
      <PageGraphic src={imgGrpahic} />
    </React.Fragment>
  );
};

export default Testmonials;
